export default[
    {
        path: '/No6IjaWUBE1119849a9f270bc59b8be6bcOL3Y9ShPN2',
        children: [
            {
                path: '10ae3908684ccc75850d49aa',
                name: 'zonesList',
                meta: {
                    title: 'Zones',
                    authRequired: true,
                    acc: ['y51656']    
                },
                component: () => import('@/views/zones/index.vue'),
            },
            {
                path: '116bb0ce1339283f9281cf88',
                name: 'createZone',
                meta: {
                    title: 'Create Zone',
                    authRequired: true,
                    acc: ['y51656']   
                },
                component: () => import('@/views/zones/new.vue'),
            },
            {
                path: '11f13581b2c6b694853d1a37/:zn?',
                name: 'ViewZone',
                meta: {
                    title: 'View Zone',
                    authRequired: true,
                    acc: ['y51656']   
                },
                component: () => import('@/views/zones/view.vue'),
            },
            {
                path: ':zn/11f13581b2c6b694853d1a37',
                name: 'EditZone',
                meta: {
                    title: 'Edit Zone',
                    authRequired: true,
                    acc: ['y51656']   
                },
                component: () => import('@/views/zones/edit.vue'),
            },
        ]
    }

]